import React from 'react'
import { connect } from 'react-redux'
import { List, Radio, Item, Label, Button} from 'semantic-ui-react'
import { Text, Translate, LanguageContext } from '../../helpers/language';
 

/** 
 * Needs the following passed as props:
 * plan: the plan
 * selected: the item is selected
 * handlePlanChange: change handler
**/
class SubscriptionItem extends React.Component {
  
  constructor(props){
    super(props)    
    this.state = {  
        trialDays: props.trialDays ? props.trialDays : 0,
        plan: props.plan,
        selected: props.selected,
        handlePlanChange: props.handlePlanChange,
        isCurrentPlan: props.isCurrentPlan,
        key: props.key,
        translations_prefix: props.translations_prefix ? props.translations_prefix : ''
    }   
  }

  componentDidUpdate(prevProps) {
    if(prevProps.selected !== this.props.selected)
        this.setState({selected: this.props.selected})
    if(prevProps.isCurrentPlan !== this.props.isCurrentPlan)
        this.setState({isCurrentPlan: this.props.isCurrentPlan})
  }

  render() {  
    const couponRedeemDate = this.state.plan.coupon && this.state.plan.coupon.redeem_by ? new Date(this.state.plan.coupon.redeem_by*1000).toLocaleDateString() : ''
    return (
        <List.Item key={this.state.key}>
        <List.Content className='radio-content'>
          
          <label className='radio-label'>
            <Radio
              name={Translate(this.context, this.state.plan.nickname).replace(/\${days}/, this.state.trialDays)}
              value={this.state.plan.id}
              checked={this.state.selected}
              onChange={this.state.handlePlanChange}
            /> 
            {Translate(this.context, this.state.translations_prefix + this.state.plan.nickname).replace(/\${days}/, this.state.trialDays)}
            {this.state.isCurrentPlan ? ' (' + Translate(this.context, 'subscription_periodic_plan_active') + ')' : ''}
          </label>
          <div style={{'marginLeft': '20px'}}>          
          <Item>              
              <Item.Content>   
                { this.state.plan.coupon && <>
                    <Label className='lisia-blue-ribbon' ribbon style={{margin: '10px', minWidth: '200px', width: '40%'}}>
                      <div><h5>{this.state.plan.coupon.name}</h5></div>
                      {this.state.plan.coupon.redeem_by && <p><i><Text tid='subscription_coupon_redeem_by' /> {couponRedeemDate}</i></p>}
                    </Label>
                  </>
                }                                 
                <Item.Meta>
                  { this.state.plan.metadata.strikeout_amount && <div style={{color: 'red'}}><del>{(this.state.plan.metadata.strikeout_amount/100.0).toFixed(2)}<Text tid={this.state.plan.currency} /></del></div>}
                  <div style={{color: 'black'}}>
                    <b>
                        {
                          this.state.plan.amount > 0.0 ? 
                            this.state.plan.coupon ?
                              <>
                              {!this.state.plan.metadata.strikeout_amount && 
                                  <div style={{color: 'red'}}>
                                    <del>{(this.state.plan.amount/100.0).toFixed(2)}<Text tid={this.state.plan.currency} />
                                    </del>
                                  </div> 
                              }
                              {this.state.plan.coupon.metadata.previous_percentage_discount && 
                                  <div style={{color: 'darkred'}}>
                                    <del>{((this.state.plan.amount - (this.state.plan.coupon.metadata.previous_percentage_discount * this.state.plan.amount/100.0))/100.0).toFixed(2)}<Text tid={this.state.plan.currency} />
                                    </del>
                                  </div> 
                              }
                              {this.state.plan.coupon.metadata.previous_amount_off && 
                                  <div style={{color: 'darkred'}}>
                                    <del>{((this.state.plan.amount - this.state.plan.coupon.metadata.previous_amount_off)/100.0).toFixed(2) }<Text tid={this.state.plan.currency} />
                                    </del>
                                  </div> 
                              }
                              <span style={{color: 'green'}}>
                                  { this.state.plan.coupon.amount_off && 
                                              ((this.state.plan.amount - this.state.plan.coupon.amount_off)/100.0).toFixed(2) 
                                  }
                                  { this.state.plan.coupon.percent_off && 
                                              ((this.state.plan.amount - (this.state.plan.coupon.percent_off * this.state.plan.amount/100.0))/100.0).toFixed(2) 
                                  }<Text tid={this.state.plan.currency} />
                                  {
                                    this.state.plan.coupon.duration === 'repeating'  && this.state.plan.recurring && <> / <Text tid={this.state.plan.recurring.interval} /> <Text tid='subscription_coupon_period_prefix' /> {this.state.plan.coupon.duration_in_months} <Text tid='months' />, <Text tid='then' />: </>
                                  }
                                  {
                                    this.state.plan.coupon.duration === 'forever' && this.state.plan.recurring && <> / <Text tid={this.state.plan.recurring.interval} /></>
                                  }
                                  {
                                    this.state.plan.coupon.duration === 'once' && this.state.plan.recurring && <> / <Text tid={this.state.plan.recurring.interval} /> <Text tid='once' />, <Text tid='then' />: </>
                                  }                              
                              </span>
                              </> 
                            :
                              <>
                                { (this.state.plan.amount/100.0).toFixed(2) }<Text tid={this.state.plan.currency} /> {this.state.plan.recurring ? <> / <Text tid={this.state.plan.recurring.interval} /> </> : '' }
                              </>
                          :
                          this.state.plan.coupon ? 
                           <> 
                             { (this.state.plan.amount/100.0).toFixed(2) }<Text tid={this.state.plan.currency} /> 
                             { this.state.plan.coupon.metadata.description && <div style={{color: 'green'}}>
                                {this.state.plan.coupon.metadata.description}
                                </div>  
                             }
                           </>
                          :
                           <> 
                            { (this.state.plan.amount/100.0).toFixed(2) }<Text tid={this.state.plan.currency} /> 
                           </>
                        }
                        {this.state.plan.recurring && this.state.trialDays > 0 && 
                          <div style={{color: 'green'}}>
                            {Translate(this.context, 'subscription_trial_disclamer_capital').replace(/\${days}/, this.state.trialDays)}
                          </div>
                        }
                    </b>
                  </div>
                </Item.Meta>
                <Item.Description>
                  { (this.state.plan.recurring || this.state.plan.interval) && this.state.plan.metadata.query_count >= 0 ? 
                    <> 
                      <Text tid='subscription_periodic_plan_active_description_prefix' /> 
                      {this.state.plan.metadata.query_count} 
                      <Text tid='subscription_periodic_plan_description_suffix' /> 
                      <Text tid={this.state.plan.recurring ? this.state.plan.recurring.interval : this.state.plan.interval} />.
                      <br/>
                    </> : 
                    <>
                      {this.state.plan.metadata.query_count >= 0 && <> {this.state.plan.metadata.query_count} <Text tid='user_profile_queries' />.</>} 
                    </>
                  }  
                  { this.state.plan.recurring && this.state.trialDays > 0 ? Translate(this.context, 'subscription_trial_disclamer')
                                                                                                   .replace(/\${days}/, this.state.trialDays)
                                                                                                   .replace(/\${interval}/, Translate(this.context, this.state.plan.recurring.interval)) 
                                                                                                 : '' 
                  }
                </Item.Description>                    
                <Item.Extra>                  
                  {(this.state.plan.recurring || this.state.plan.interval) && 
                      <>   
                        { this.state.trialDays > 0 ? <>       
                            <i>
                              <Text tid='subscription_free_deactivation' />                       
                              <b> 
                                {Translate(this.context, 'subscription_renews_on_trial_expiration')
                                .replace(/\${interval}/, Translate(this.context, this.state.plan.recurring.interval))
                                }  
                              </b> 
                            </i>
                          </>
                          : 
                          <>
                            <b><i> 
                              {Translate(this.context, 'subscription_renews_on_expiration')
                                .replace(/\${interval}/, Translate(this.context, this.state.plan.recurring.interval)) } 
                            </i></b>  
                          </>
                        }
                      </>              
                        
                    }
                </Item.Extra>
              </Item.Content>
            </Item>
          </div>
        </List.Content>
      </List.Item>  
    )
  }
}

SubscriptionItem.contextType = LanguageContext;

SubscriptionItem.propTypes = {

}

const mapStateToProps = (state) => ({
})

export default connect(mapStateToProps)(SubscriptionItem)
